
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.main = this.closest('main-product');
    // this.isPre = document.querySelector('main-product').dataset;
    this.variantInfoWarp = this.main.querySelector(".product_short_description");
    this.isPre = document.querySelector('main-product').dataset.isPre;
    this.addEventListener('change', this.onVariantChange);
    this.updateCode()
  }
  /**
   * 更新变体
   */
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    // this.updatePickupAvailability();
    this.removeErrorMessage();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.toggleAddButton(true, '', false);
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
    this.updateCode()
    var integralBox = document.getElementById('integral-product');
    var myIntegral = integralBox.querySelector('.integral');
    var myQuantity = document.getElementsByName('quantity');
    myIntegral.setAttribute("data-product-list", `[${JSON.stringify(this.currentVariant)}]`);
    updateIntegral({
      domId: 'integral-product',
      productList: [this.currentVariant],
      quantity: myQuantity[0].value,
      type: 'product'
    })
  }
  
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('[data-options]'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  
  /**
   * 跟新变体图片
   */
  updateMedia() {
    const mainProductCom = document.querySelector('main-product');
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const index = document.querySelector(`[data-thumbnail-id="${this.currentVariant.featured_media.id}"]`).dataset.index;
    mainProductCom.sliderTo(this.currentVariant.featured_media.id, index)
    
  }
  
  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  
  /**
   * 更新快速结账匹配产品ID
   */
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }
  
  // updatePickupAvailability() {
  //   const pickUpAvailability = document.querySelector('pickup-availability');
  //   if (!pickUpAvailability) return;
  //
  //   if (this.currentVariant?.available) {
  //     pickUpAvailability.fetchAvailability(this.currentVariant.id);
  //   } else {
  //     pickUpAvailability.removeAttribute('available');
  //     pickUpAvailability.innerHTML = '';
  //   }
  // }
  
  /**
   * 更新产品状态
   * @returns {Promise<void>}
   */
  async renderProductInfo() {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    const id = `price-${this.dataset.section}`;
    const destination = document.getElementById(id);

    
    this.source = await fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        return html.getElementById(id);
      });
    if (this.source && destination) destination.innerHTML = this.source.innerHTML;
    document.getElementById(`price-${this.dataset.section}`).classList.remove('visibility-hidden');
    this.toggleAddButton(!this.currentVariant.available, window.languages.productFormSoldOut);
  }
  
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]').querySelector('span');
    
    if (!addButton) return;
    
    // const idPre = Boolean(this.isPre);
    const idPre = JSON.parse(this.isPre);
    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonInnerHtml.textContent = text;
    } else {
      if (idPre) {
        addButton.removeAttribute('disabled');
        addButtonInnerHtml.textContent = window.languages.productFormPre;
      } else {
        addButton.removeAttribute('disabled');
         // 修改定金按钮显示
        if(this.options[0] === 'deposit'){
          addButtonInnerHtml.textContent = "Reserve Now";
        }else{
           addButtonInnerHtml.textContent = window.languages.productFormAddToCart;
        }   
      }
    }
    
    if (!modifyClass) return;
  }
  
  
  /**
   * 变体不存在时禁用按钮和价格
   */
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]');
    const addButtonInnerHtml = document.getElementById(`product-form-${this.dataset.section}`).querySelector('[name="add"]').querySelector('span');
    if (!addButton) return;
    addButtonInnerHtml.textContent = window.languages.productFormUnavailable;
    document.getElementById(`price-${this.dataset.section}`).classList.add('uk-hidden');
  }
  
  /**
   * 获取产品json并缓存
   * @returns {*}
   */
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  
  /**
   * 购物车超过库存数量时提示错误信息
   */
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
  
  /**
   * 变体折扣码
   */
  updateCode() {
      let tm_discount = this.main.querySelector('.tm-discount-variant')
      let tm_discount_code =  this.main.querySelector('.tm-discount-code')
      let tm_discount_date =  this.main.querySelector('.tm-discount-date')
      let tm_discount_des =  this.main.querySelector('.tm-discount-des')
      let tm_discount_coupon =  this.main.querySelector('.tm-discount-coupon')
      const url = window.location.href;
      const { url: urlWithoutParams, paramValue } = this.parseUrl(url, 'variant');
      fetch(`${urlWithoutParams}?view=json`)
      .then(response => response.json())
      .then(responseData => {
        // 在此处对 responseData 进行处理
        if(responseData && responseData.coupon != null) {
          let coupon = responseData.coupon
          const foundObjs = coupon.filter(obj => obj.hasOwnProperty(paramValue));
          if(foundObjs.length <= 0 || tm_discount == null) return;
          if(foundObjs[0][paramValue] != null) {
              tm_discount.setAttribute("style", "display: block !important")
              tm_discount.dataset.discount = foundObjs[0][paramValue].code;
              tm_discount_code.innerHTML = foundObjs[0][paramValue].code;
              if(foundObjs[0][paramValue].start && foundObjs[0][paramValue].end ) tm_discount_date.innerHTML = foundObjs[0][paramValue].start + '~' + foundObjs[0][paramValue].end;
              tm_discount_des.innerHTML = foundObjs[0][paramValue].des;
              tm_discount_coupon.innerHTML = foundObjs[0][paramValue].coupon;
          }else {
            tm_discount.setAttribute("style", "display: none !important")
          }
        }else {
          tm_discount.setAttribute("style", "display: none !important")
        }
      });
    }
    removeQueryParams(url) {
      const index = url.indexOf('?');
      if (index !== -1) {
        return url.substring(0, index);
      } else {
        return url;
      }
    }
    parseUrl(url, paramName) {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      const paramValue = params.get(paramName);
      return {
        url: urlObj.origin + urlObj.pathname,
        paramValue: paramValue
      };
    }
}

customElements.define('variant-radios', VariantRadios);

class MainProduct extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slideshowElement: this.querySelector('[uk-slideshow]'),
      sliderElement: this.querySelector('[uk-slider]'),
      iframeBtn: this.querySelectorAll('[data-code]')
    }
    
    this.selectors.slideshowElement.addEventListener('itemshow', (event) => {
      UIkit.slider(this.selectors.sliderElement).show(event.target.dataset.imageIndex);
      this.sliderTo(event.target.dataset.mediaId);
    });
    
    this.fixSlideClick();
    this.videoClickEvent();

    updateIntegral({
      domId: 'integral-product'
    })
  }
  
  videoClickEvent() {
    const sLis = UIkit.util.queryAll('.tm-main-product [uk-slideshow] li [data-code]');
    if (sLis.length === 0) return;
    UIkit.util.on(sLis, 'click', (event) => {
      const {code} = event.target.dataset;
      if (code) {
        code.indexOf('<video') === -1 ? this.play(code) : this.play(code, false);
      }
    }, false);
  }
  
  sliderTo(mediaId, index) {
    if (mediaId) {
      UIkit.util.removeClass(UIkit.util.queryAll('.tm-main-product [uk-slider] img'), 'tm-active');
      this.querySelector(`[data-thumbnail-id="${mediaId}"] img`).classList.add('tm-active');
    }
    if (index) {
      UIkit.slider(this.selectors.sliderElement).show(index);
      UIkit.slideshow(this.selectors.slideshowElement).show(index);
    }
  }
  
  fixSlideClick() {
    const oLis = UIkit.util.queryAll('.tm-main-product [uk-slider] li');
    UIkit.util.on(oLis, 'click', (event) => {
      const {index, thumbnailId} = event.target.dataset;
      this.sliderTo(thumbnailId, index);
    });
  }
  
  play(code, state = true) {
    let videoElement, videoUrl;
    if (!code) return;
    if (state) {
      videoUrl = `//www.youtube-nocookie.com/embed/${code}?autoplay=0&amp;showinfo=0&amp;rel=0&amp;modestbranding=1&amp;playsinline=1`;
      videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button><iframe src="${videoUrl}" width="1920" height="1080" allowfullscreen uk-responsive uk-video></iframe>`
    } else {
      videoElement = `<button class="uk-modal-close-outside" type="button" uk-close></button>${code}`
    }
    UIkit.modal.dialog(`<div>${videoElement}<style>.uk-modal{display: flex!important;}.uk-modal-dialog {width: 1200px;margin-top: auto!important;margin-bottom: auto!important;}</style></div>`);
  }
}

customElements.define('main-product', MainProduct);
